import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { timeAgo } from "@/lib/tiers";
import { Users } from "lucide-react";

export function ActivityTicker() {
  const [items, setItems] = useState([]);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let mounted = true;
    const fetchIt = async () => {
      try {
        const { data } = await api.get("/waitlist/activity/recent?limit=1");
        if (mounted) setItems(data || []);
      } catch {
        /* ignore */
      }
    };
    fetchIt();
    const it = setInterval(fetchIt, 25000);
    const it2 = setInterval(() => setTick((t) => t + 1), 15000);
    return () => {
      mounted = false;
      clearInterval(it);
      clearInterval(it2);
    };
  }, []);

  if (!items.length) return null;
  const last = items[0];
  return (
    <div
      data-testid="activity-ticker"
      className="inline-flex items-center gap-2 border border-white/20 backdrop-blur-md bg-white/5 px-4 py-2 text-[11px] tracking-[0.18em] uppercase text-white/80"
    >
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400/70"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400"></span>
      </span>
      <Users size={12} className="opacity-80" />
      <span>
        {last.email_masked} · <span className="text-white">{timeAgo(last.created_at)}</span>
      </span>
    </div>
  );
}
